import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { goTo } from "@/lib/api";
import { AccountMenu, MobileAccountItem } from "@/components/account/AccountMenu";

const LINKS = [["cycle", "Cycle"], ["kitchen", "Nourish"], ["pillars", "Faith"], ["style", "Style"], ["budget", "Budget"], ["demo", "Try it"]];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const nav = (id) => { setOpen(false); goTo(id); };
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, delay: 0.1 }}
      className="fixed inset-x-0 top-3 z-50 px-3 sm:top-5 sm:px-6"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between rounded-full border border-[#C86D51]/15 bg-[#FDFBF7]/75 px-4 py-2.5 backdrop-blur-xl sm:px-6">
        <button onClick={() => nav("top")} data-testid="nav-logo-button"><Logo /></button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([id, label]) => (
            <a key={id} href={`#${id}`} onClick={(e) => { e.preventDefault(); nav(id); }} data-testid={`nav-link-${id}`}
              className="group relative text-sm text-[#5C4A42] transition-colors hover:text-[#2C221E]">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#9E4429] transition-transform duration-300 group-hover:scale-x-100" />
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <AccountMenu />
          <button onClick={() => nav("waitlist")} data-testid="waitlist-modal-trigger-button"
            className="rounded-full bg-[#2C221E] px-4 py-2 text-sm font-medium text-[#FBF5EE] transition-colors hover:bg-[#9E4429]">
            Get early access
          </button>
          <button className="p-2 md:hidden" onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="mx-auto mt-2 max-w-7xl rounded-3xl border border-[#C86D51]/15 bg-[#FDFBF7]/95 p-4 backdrop-blur-xl md:hidden">
            {LINKS.map(([id, label]) => (
              <button key={id} onClick={() => nav(id)} data-testid={`nav-mobile-link-${id}`}
                className="block w-full py-3 text-left font-serif text-2xl text-[#2C221E]">{label}</button>
            ))}
            <MobileAccountItem onDone={() => setOpen(false)} />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
